<template>
  <analytics-sub-page
    title="Savings Analytics"
    icon="piggy-bank"
    css-class="analytics-savings"
    default-label="Savings"
    :section-specs="sectionSpecs"
  >
    <build-metrics ref="buildRef" />
  </analytics-sub-page>
</template>

<script setup>
import { ref } from 'vue';
import AnalyticsSubPage from '@/components/AnalyticsSubPage.vue';
import BuildMetrics from '@/pages/analyticsApp/components/BuildMetrics.vue';

const buildRef = ref(null);

// BuildMetrics renders several logical subsections (Savers / Deposits /
// Interest / External deposits / Balances / Prizes). Each spec scopes capture
// to the matching `data-pdf-section` marker so the modal lists them separately
// and PDFs only include the selected subsections.
const sectionFor = (sectionKey, hasDataKey, exportTableKey) => ({
  hasData: () => !!buildRef.value?.[hasDataKey],
  getContainerEl: () => buildRef.value?.$el?.querySelector(`[data-pdf-section="${sectionKey}"]`) || buildRef.value?.$el,
  getExportTable: () => buildRef.value?.[exportTableKey]?.() ?? null,
});

const sectionSpecs = [
  { key: 'savers', label: 'Savers', ...sectionFor('savers', 'hasSaversData', 'getSaversExportTable') },
  { key: 'deposits', label: 'Deposits', ...sectionFor('deposits', 'hasDepositsData', 'getDepositsExportTable') },
  { key: 'interest', label: 'Interest', ...sectionFor('interest', 'hasInterestData', 'getInterestExportTable') },
  {
    key: 'external',
    label: 'External deposits',
    ...sectionFor('external', 'hasExternalDeposits', 'getExternalExportTable'),
  },
  { key: 'balances', label: 'Balances', ...sectionFor('balances', 'hasBalancesData', 'getBalancesExportTable') },
  { key: 'prizes', label: 'Prizes', ...sectionFor('prizes', 'hasPrizeMetrics', 'getPrizesExportTable') },
];
</script>
